import { ChartType } from '../../types/prism';
const stackedChartTypes = [
    ChartType.StackedArea,
    ChartType.StackedColumn,
    ChartType.StackedBar,
    ChartType.LineStackedColumn,
];
const isStackedChart = (chartType) => stackedChartTypes.includes(chartType);
export { isStackedChart };
//# sourceMappingURL=common-util.js.map